module.exports = __webpack_public_path__ + "static/media/arac-logo.2b70eb5e.png";